var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"progress"},[_vm._v(_vm._s(_vm.progress))])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anim"},[_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }